import { PASSWORD } from '../Utils/constants';

const initialState = {
	error: null,
	loading: false,
	message: null,
};

export default (state = initialState, action) => {
	switch (action.type) {
		case PASSWORD.CREATE_PASSWORD:
		case PASSWORD.CREATE_PASSWORD_FAILED:
			return {
				...state,
				error: action.error,
				loading: false,
				message: null,
			};
		case PASSWORD.CREATE_PASSWORD_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				message: action.message,
			};
		default:
			return state;
	}
};
